import createCachedSelector from 're-reselect';
import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import * as model from '../../model';
import { Actions, StoreState } from '../types';

type Wrapups = Record<string, model.Wrapup[] | undefined>

function wrapups(state: Wrapups = {}, action: Actions): Wrapups {
  switch (action.type) {
    case getType(actions.fetchWrapupFolder.response): {
      return {
        ...state,
        [action.payload.folderId]: action.payload.items,
      }
    }

    case getType(actions.fetchWrapupsDeep.response): {
      state = { ...state }
      for (const [id, items] of Object.entries(action.payload)) {
        state[id] = [ ...items, ...(state[id] || []).filter(x => !x.folder) ]
      }

      return state
    }
  }

  return state
}

type Parents = Record<string, string | null>

function parents(state: Parents = { SYS: null }, action: Actions): Parents {
  switch (action.type) {
    case getType(actions.fetchWrapupFolder.response): {
      state = { ...state }
      for (const item of action.payload.items) {
        state[item.id] = action.payload.folderId
      }
      return state
    }

    case getType(actions.fetchWrapupsDeep.response): {
      state = { ...state }
      for (const [id, items] of Object.entries(action.payload)) {
        for (const item of items) {
          state[item.id] = id
        }
      }

      return state
    }
  }

  return state
}

type ItemsLoaded = Record<string, true | undefined>

function itemsLoaded(state: ItemsLoaded = {}, action: Actions): ItemsLoaded {
  switch (action.type) {
    case getType(actions.fetchWrapupFolder.response): {
      return {
        ...state,
        [action.payload.folderId]: true,
      }
    }
  }

  return state
}

export default combineReducers({
  wrapups,
  parents,
  itemsLoaded,
})

function getRoot(state: StoreState) { return state.wrapups }
function getWrapups(state: StoreState) { return getRoot(state).wrapups }
function getParents(state: StoreState) { return getRoot(state).parents }
function getItemsLoaded(state: StoreState) { return getRoot(state).itemsLoaded }

export function selectWrapups(state: StoreState, folderId: string = 'SYS') {
  return getItemsLoaded(state)[folderId] ? getWrapups(state)[folderId] : undefined
}

export function shouldFetchWrapups(state: StoreState, folderId: string) {
  return !getWrapups(state)[folderId]
}

export function shouldFetchWrapupItems(state: StoreState, folderId: string) {
  return !getItemsLoaded(state)[folderId]
}

export const selectWrapupsPath = createCachedSelector(
  getParents,
  (_: StoreState, folderId: string) => folderId,
  (parents, folderId) => {
    const path = [ folderId ]
    let f: string | null = folderId
    for (;;) {
      f = parents[f]
      if (!f) { break }
      path.unshift(f)
    }

    return path
  })(
    (_, folderId) => folderId,
  )
